// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-8bb73d4e] .el-result {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n[data-v-8bb73d4e] .el-result__icon svg {\n\twidth: 40px;\n\theight: 40px;\n}\n[data-v-8bb73d4e] .el-result .icon-success {\n\tfill: #FF6637;\n}\n[data-v-8bb73d4e] .el-empty__bottom,[data-v-8bb73d4e] .el-result__title {\n\tmargin-top: 0px;\n\tmargin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
